import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('https://dpt.saigoniot.vn:444/api/User/auth-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      console.log('API Response:', data); // Thêm log để kiểm tra phản hồi

      // Kiểm tra status và dữ liệu trả về
      if (!response.ok || data.status !== 1) {
        throw new Error(data.error || 'Thông tin đăng nhập không hợp lệ');
      }

      const { access_token, fullname } = data.data;
      localStorage.setItem('token', access_token);
      localStorage.setItem('fullname', fullname); // Lưu fullname vào localStorage

      login(access_token, fullname); // Truyền cả token và fullname
      toast.success('Đăng nhập thành công!', {
        position: 'top-center',
        autoClose: 3000,
      });
      history.push('/');
    } catch (err) {
      setError(err.message);
      toast.error(`Đăng nhập thất bại: ${err.message}`, {
        position: 'top-center',
        autoClose: 5000,
      });
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-2xl font-bold mb-4 text-center">Đăng nhập</h2>
        {error && <div className="text-red-500 mb-4">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Tên đăng nhập</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="border p-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Mật khẩu</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border p-2 rounded w-full"
              required
            />
          </div>
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded w-full hover:bg-blue-600"
          >
            Đăng nhập
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;